import { apiGet } from '@/store/api';
import { useAttendanceStore } from '@/store/attendanceStore';

export async function getInAttendance() {
  const data = await apiGet('attendance/isActive/');
  useAttendanceStore().setInAttendance(data);
  return data;
}
